import React from "react";
import isHomePage from "../../utilities/isHomePage";

function Breadcrumbs(props) {
  const breadcrumbsData = props.breadcrumbsData || {
    displayBreadcrumbs: false,
    links: []
  };

  if (
    isHomePage() ||
    !breadcrumbsData.displayBreadcrumbs ||
    !breadcrumbsData.links
  ) {
    return false;
  } else {
    const breadcrumbStructuredData = {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      itemListElement: breadcrumbsData.links.map((item, index, arr) => {
        if (index == arr.length - 1) {
          return {
            "@type": "ListItem",
            position: index + 1,
            name: item.pageName
          };
        } else {
          return {
            "@type": "ListItem",
            position: index + 1,
            name: item.pageName,
            item: item.pageURL
          };
        }
      })
    };

    return (
      <div className="breadcrumbs-social-container container-fluid">
        <script type="application/ld+json">
          {JSON.stringify(breadcrumbStructuredData)}
        </script>
        <div className="row">
          <div className="col-12">
            <nav id="breadcrumbs">
              <ul>
                {breadcrumbsData.links.map((item, index, arr) => {
                  {
                    if (index == arr.length - 1) {
                      return <li key={index}>{item.pageName}</li>;
                    } else {
                      return (
                        <li key={index}>
                          <a href={item.pageURL}>{item.pageName}</a>
                        </li>
                      );
                    }
                  }
                })}
              </ul>
            </nav>
          </div>
        </div>
      </div>
    );
  }
}

export default Breadcrumbs;
